var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.superposition ? 'width-40' : '',attrs:{"id":"arrow-joint-wrapper"}},[_c('div',{class:_vm.superposition
        ? 'arrow-color-1'
        : _vm.color1 == 'white'
        ? 'arrow-start-no-color'
        : 'arrow-start-color',attrs:{"name":"part1"}}),_c('div',{class:_vm.superposition ? 'arrow-color-2' : '',attrs:{"name":"part2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }